import React, { useState } from 'react';
import {
  FiClock,
  FiFacebook,
  FiInstagram,
  FiMail,
  FiMapPin,
  FiPhone,
  FiSend,
  FiYoutube
} from 'react-icons/fi';

const contactCards = [
  {
    icon: <FiMapPin size={20} />,
    title: 'Alamat',
    content: (
      <>
        XSignature
        <br />
        Jl. Raya Serpong KM 7, Pakulonan
        <br />
        Tangerang Selatan, Banten
      </>
    )
  },
  {
    icon: <FiPhone size={20} />,
    title: 'Telepon',
    content: '0813-7200-0898'
  },
  {
    icon: <FiMail size={20} />,
    title: 'Email',
    content: (
      <>
        info@xsignature.com
        <br />
        booking@xsignature.com
      </>
    )
  },
  {
    icon: <FiClock size={20} />,
    title: 'Jam Operasional',
    content: (
      <>
        Senin - Minggu: 09:00 - 18:00
        <br />
        Selasa: Tutup
      </>
    )
  }
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitSuccess(false);
    setSubmitError(false);

    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    }, 1500);
  };

  return (
    <div className="min-h-screen pt-[72px]">
      <section className="bg-slate-950 py-24 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="mt-6 text-4xl font-bold leading-tight md:text-5xl">
              Hubungi kami untuk konsultasi custom lampu, detailing, dan upgrade parts
            </h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">
              Jika Anda ingin membahas custom projector headlamp, foglamp, body kit, coating, detailing,
              atau product line seperti Profender, YSS, JS1, HKS, dan UR, tim kami siap membantu.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-0 border-t border-slate-200 md:grid-cols-2 xl:grid-cols-4">
            {contactCards.map((card) => (
              <div
                key={card.title}
                className="border-b border-slate-200 px-0 py-6 md:px-6"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-orange-200 text-primary">
                  {card.icon}
                </div>
                <h2 className="mt-4 text-lg font-semibold text-secondary">{card.title}</h2>
                <div className="mt-2 text-sm leading-6 text-slate-600">{card.content}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-5">
            <div className="lg:col-span-2 border-t border-slate-200 pt-8 text-slate-900">
              <h2 className="text-2xl font-bold">Informasi Kontak</h2>
              <p className="mt-4 text-sm leading-7 text-slate-600">
                Anda bisa menghubungi kami melalui telepon, email, atau datang langsung ke lokasi.
                Untuk project custom dan pemesanan parts, kami sarankan konsultasi lebih dulu supaya arahnya lebih tepat.
              </p>

              <div className="mt-8 border-t border-slate-200 pt-5">
                <div className="text-sm font-semibold uppercase tracking-wide text-primary">Google Maps</div>
                <a
                  href="https://maps.app.goo.gl/TX6UaVwSt7ttz1T47"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-flex items-center text-sm font-medium text-slate-900 hover:text-primary"
                >
                  Lihat lokasi
                </a>
              </div>

              <div className="mt-8 border-t border-slate-200 pt-5">
                <div className="text-sm font-semibold uppercase tracking-wide text-primary">Media Sosial</div>
                <div className="mt-4 flex gap-3">
                  <button className="rounded-full border border-slate-300 p-3 text-slate-700 transition-colors hover:border-primary hover:text-primary">
                    <FiInstagram size={18} />
                  </button>
                  <button className="rounded-full border border-slate-300 p-3 text-slate-700 transition-colors hover:border-primary hover:text-primary">
                    <FiFacebook size={18} />
                  </button>
                  <button className="rounded-full border border-slate-300 p-3 text-slate-700 transition-colors hover:border-primary hover:text-primary">
                    <FiYoutube size={18} />
                  </button>
                </div>
              </div>
            </div>

            <div className="lg:col-span-3 border-t border-slate-200 pt-8">
              <h2 className="text-2xl font-bold text-secondary">Kirim Pesan</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                Isi form berikut untuk konsultasi layanan, product line, atau kebutuhan build kendaraan Anda.
              </p>

              {submitSuccess && (
                <div className="mt-6 rounded-lg border border-green-200 bg-green-50 p-4 text-sm font-medium text-green-700">
                  Pesan Anda berhasil dikirim. Tim kami akan segera menghubungi Anda untuk tindak lanjut konsultasi.
                </div>
              )}

              {submitError && (
                <div className="mt-6 rounded-lg border border-red-200 bg-red-50 p-4 text-sm font-medium text-red-700">
                  Terjadi kesalahan saat mengirim pesan. Silakan coba lagi nanti.
                </div>
              )}

              <form onSubmit={handleSubmit} className="mt-8">
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                  <div>
                    <label htmlFor="name" className="form-label">Nama Lengkap</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="form-label">Nomor Telepon</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                  <div>
                    <label htmlFor="subject" className="form-label">Subjek</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                </div>

                <div className="mt-6">
                  <label htmlFor="message" className="form-label">Pesan</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    className="form-input"
                    required
                  />
                </div>

                <div className="mt-8">
                  <button
                    type="submit"
                    className="btn btn-primary px-8"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="mr-2 h-5 w-5 animate-spin rounded-full border-b-2 border-t-2 border-white" />
                        Mengirim...
                      </>
                    ) : (
                      <>
                        <FiSend className="mr-2" />
                        Kirim Pesan
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="container mx-auto px-4">
          <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm">
            <div className="border-b border-gray-100 px-8 py-6">
              <h2 className="text-2xl font-bold text-secondary">Lokasi Kami</h2>
              <p className="mt-2 text-sm leading-6 text-gray-600">
                Temukan lokasi XSignature melalui peta berikut.
              </p>
            </div>
            <div className="h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.153556553864!2d106.66532827586744!3d-6.24254166124805!2m3!1f0!2f0!3f0!2m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69fb7ad9f30015%3A0x248e9227b4b1f22!2sXSignature%20Auto%20Garage!5e0!3m2!1sen!2sid!4v1718339857381!5m2!1sen!2sid"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="XSignature Location"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
